import React, { useEffect, useState } from 'react';

import { Grid } from '@mui/material';
import EinstellungenSeitenKopf from '../components';

interface EnvJson {
  GIT_COMMIT: string;
  GIT_COMMIT_TIME: string;
  CI_PIPELINE_ID: string;
  CI_COMMIT_BRANCH: string;
}

export default function AdminPage() {
  const [appInformation, setAppInformation] = useState<EnvJson>({
    GIT_COMMIT: '',
    GIT_COMMIT_TIME: '',
    CI_PIPELINE_ID: '',
    CI_COMMIT_BRANCH: '',
  });
  // CONTRACT: HTTP error (non-ok response) → throws → caught → returns empty fallback
  // CONTRACT: network rejection (abort, DNS failure) → caught → returns empty fallback
  // CONTRACT: JSON parse failure → caught → returns empty fallback
  // CONTRACT: non-object or null payload → normalised to empty fallback (no crash)
  // CONTRACT: missing or non-string field → defaulted to empty string per field
  function getAppBuildInformation(): Promise<EnvJson> {
    const empty: EnvJson = { GIT_COMMIT: '', GIT_COMMIT_TIME: '', CI_PIPELINE_ID: '', CI_COMMIT_BRANCH: '' };
    return fetch('/static/env.json')
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((data: unknown) => {
        if (!data || typeof data !== 'object' || Array.isArray(data)) return empty;
        const d = data as Record<string, unknown>;
        return {
          GIT_COMMIT: typeof d.GIT_COMMIT === 'string' ? d.GIT_COMMIT : '',
          GIT_COMMIT_TIME: typeof d.GIT_COMMIT_TIME === 'string' ? d.GIT_COMMIT_TIME : '',
          CI_PIPELINE_ID: typeof d.CI_PIPELINE_ID === 'string' ? d.CI_PIPELINE_ID : '',
          CI_COMMIT_BRANCH: typeof d.CI_COMMIT_BRANCH === 'string' ? d.CI_COMMIT_BRANCH : '',
        };
      })
      .catch(() => empty);
  }

  useEffect(() => {
    getAppBuildInformation().then((response) => {
      setAppInformation(response);
    });
  }, []);

  return (
    <>
      <EinstellungenSeitenKopf title="Info" />
      <Grid xs={12} container direction="column" justifyContent="flex-start" alignItems="flex-start">
        <Grid item>
          {appInformation.GIT_COMMIT && <div>GIT_COMMIT: {appInformation.GIT_COMMIT}</div>}
          {appInformation.GIT_COMMIT_TIME && <div>GIT_COMMIT_TIME: {appInformation.GIT_COMMIT_TIME}</div>}
          {appInformation.CI_PIPELINE_ID && <div>CI_PIPELINE_ID: {appInformation.CI_PIPELINE_ID}</div>}
          {appInformation.CI_COMMIT_BRANCH && <div>CI_COMMIT_BRANCH: {appInformation.CI_COMMIT_BRANCH}</div>}
          <div>REACT_APP_ENV: {process.env.REACT_APP_ENV}</div>
          <div>NODE_ENV: {process.env.NODE_ENV}</div>
        </Grid>
      </Grid>
    </>
  );
}
